import { AccountApi } from "./account.api";


const accountApi = new AccountApi();

export { accountApi };
